import { useState, useCallback } from "react";

const useModal = () => {
  const [modal, setModal] = useState({});

  const getModalState = useCallback((id) => (id ? modal[id] : modal), [modal]);

  const updateModalState = useCallback((action, id, isEdit) => {
    if (!action || !id) return;
    setModal((prev) => {
      return {
        ...prev,
        [id]: {
          isOpen: action === "open" ? true : false,
          isEdit: action === "close" ? false : isEdit
        },
      };
    });
  }, []);

  const open = useCallback((id, edit) => {
    updateModalState("open", id, edit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const close = useCallback((id) => {
    updateModalState("close", id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    getModalState,
    open,
    close,
  };
};

export default useModal;
